import RestApiModel from "@/api/Model/RestApiModel";

class PrintIssueMethod extends RestApiModel {
  static getResourceEndpoint() {
    return '/facility-print-issue-methods';
  }
}

export default PrintIssueMethod;
